import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { State } from "../../../redux/slices";
import EditLocationForm from "./EditLocationForm";

import MenuEditLocationPreset from "./MenuEditLocation";

const EditLocation: FC<any> = () => {
  const { locationSelectedIs } = useSelector(
    (state: State) => state.GrainWiseEditionReducer,
  );
  const { selectedLocation } = useSelector(
    (state: State) => state.GrainWiseEditionReducer,
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (!selectedLocation.values.id) {
      navigate("/locations");
    }
  }, []);

  return (
    <div className="create-sites-container">
      <MenuEditLocationPreset />

      {locationSelectedIs.EditingValues ? <EditLocationForm /> : ""}
    </div>
  );
};

export default EditLocation;
